:host,
:host * {
  box-sizing: border-box;
}

:host {
  position: relative;
  z-index: 91;
}

:host(:not([open])) {
  display: none;
}

#banner {
  display: flex;
  justify-content: center;
  min-height: 56px;
  padding: 0px 120px;
  position: relative;
  overflow: hidden;
  background: var(--grid-background-color-01);
}

#banner::before,
#banner::after {
  content: '';
  display: block;
  position: absolute;
  border-radius: 50%;
  z-index: 0;
}

#banner::before {
  width: 380px;
  aspect-ratio: 1;
  background: var(--grid-background-product-04);
  top: 0;
  left: -244px;
}

#banner::after {
  width: 112px;
  aspect-ratio: 1;
  background: var(--grid-background-color-09);
  right: -36px;
  top: -45px;
}

#content-wrapper {
  display: flex;
  align-items: center;
  gap: 24px;
  width: 100%;
  z-index: 1;
  position: relative;
}

::slotted([slot='title']) {
  color: var(--grid-content-primary) !important;
  font: var(--label-3) !important;
  max-width: 180px;
  padding: 8px 0 !important;
}

#body {
  flex: 1;
  padding-right: 40px;
}

::slotted([slot='body-desktop']),
::slotted([slot='body-mobile']) {
  color: var(--grid-content-primary) !important;
  font: var(--body-3) !important;
  padding: 8px 0 !important;
}

#close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
}

@media screen and (max-width: 1439px) {
  #banner {
    padding-left: 30px;
    padding-right: 88px;
  }
}

@media screen and (max-width: 989px) {
  #banner {
    padding-right: 72px;
  }

  ::slotted([slot='title']) {
    max-width: 148px;
    font: var(--label-5) !important;
  }

  ::slotted([slot='body-desktop']),
  ::slotted([slot='body-mobile']) {
    font-size: 12px;
  }
}

@media screen and (max-width: 767px) {
  #banner {
    padding-left: 16px;
    padding-right: 64px;
  }

  #content-wrapper {
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
  }

  ::slotted([slot='title']) {
    max-width: 100%;
    padding-bottom: 4px !important;
  }

  #body {
    padding-right: 0;
  }

  ::slotted([slot='body-desktop']),
  ::slotted([slot='body-mobile']) {
    padding: 0 !important;
    font: var(--body-4) !important;
  }
}
